module.exports = __webpack_public_path__ + "static/media/soundcloud.4ebc3c05.svg";